var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.505 7.813L15.719 11m0 0l-3.214 3.188M15.719 11H7.146m13.932 0c0 1.256-.25 2.5-.735 3.66a9.558 9.558 0 01-2.09 3.102 9.65 9.65 0 01-3.13 2.073 9.716 9.716 0 01-7.381 0 9.65 9.65 0 01-3.129-2.073 9.558 9.558 0 01-2.09-3.103A9.492 9.492 0 011.787 11a9.521 9.521 0 012.825-6.762 9.687 9.687 0 016.82-2.8 9.687 9.687 0 016.82 2.8A9.521 9.521 0 0121.078 11z",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/arrow-right.0be2ac64.svg";
export { SvgArrowRight as ReactComponent };